import React, { useEffect, useState, useRef } from "react";
import apiDefinitions from "../../../api/apiDefinitions";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import { Pagination, Form, OverlayTrigger, Popover } from "react-bootstrap";
import {
  priority,
  status,
} from "../../../core/common/selectoption/selectoption";
import toast from "react-hot-toast";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import Select, { MultiValue } from "react-select";
import * as XLSX from "xlsx";
import { ac, co } from "@fullcalendar/core/internal-common";
import { set } from "date-fns";

const ViewAllRepresentatives = () => {
  const route = all_routes;
  const navigate = useNavigate();
  const hasDataLoaded = useRef(false);
  const [employeeId, setEmployeeId] = useState("");
  const [leads, setLeads] = useState<Lead[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [employeeList, setEmployeeList] = useState<any[]>([]);
  const [searchKey, setSearchKey] = useState("");
  const [searchClicked, setSearchClicked] = useState(false);

  const [representativeName, setRepresentativeName] = useState("");
  const [contact, setContact] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [email, setEmail] = useState("");
  const [Address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [nic, setNic] = useState("");
  const [dob, setDob] = useState("");

  const [refresh, setRefresh] = useState(false);
  const [selectedRepresentativeId, setSelectedRepresentativeId] = useState<
    number | null
  >(null);

  const [isRepresentativeNameValid, setIsRepresentativeNameValid] =
    useState(false);
  const [isContactValid, setIsContactValid] = useState(false);
  const [isWhatsappValid, setIsWhatsappValid] = useState(false);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isAddressValid, setIsAddressValid] = useState(false);
  const [isNicValid, setIsNicValid] = useState(false);
  const [isDobInvalid, setIsDobInvalid] = useState(false);
  const [filterStatus, setFilterStatus] = useState("");

  interface DecodedToken {
    exp: number;
    [key: string]: any;
  }

  interface Lead {
    id: number;
    name: string;
    phone: number;
    email: number;
    nic: string;
    activeInactiveStatus: boolean;
  }

  interface FetchLeadsResponse {
    content: Lead[];
    totalElements: number;
    totalPages: number;
  }

  useEffect(() => {
    const fetchData = async () => {
      const token = sessionStorage.getItem("token");
      if (!token) {
        console.error("No token found. Please log in again.");
        navigate(route.login); // Redirect to login if no token
        return;
      }

      try {
        const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
        const currentTime = Math.floor(Date.now() / 1000);

        if (decodedToken.exp && decodedToken.exp <= currentTime) {
          console.log("Session expired. Please log in again.");
          navigate(route.login);
          return;
        }

        if (!hasDataLoaded.current) {
          hasDataLoaded.current = true;
          return;
        }

        const offset = currentPage - 1;

        const toastId = toast.loading("Loading Data...");
        try {
          const response = await apiDefinitions.getAllRepresentatives(
            token,
            searchKey,
            filterStatus,
            offset,
            itemsPerPage
          );

          if (response.data.code === 200) {
            toast.dismiss(toastId);
            toast.success("Data Loaded", { duration: 5000 });
            // const data: FetchLeadsResponse = response.data.data;
            setLeads(response.data.data.contacts);
            setTotalPages(response.data.data.totalPages);
          } else if (response.data.code === 404) {
            toast.dismiss(toastId);
            toast.error("No representatives Were Found", { duration: 5000 });
          } else {
            toast.dismiss(toastId);
            toast.error("Failed to fetch representatives. Please try again.");
          }
        } catch (error) {
          toast.dismiss(toastId);
          console.error("Failed to fetch representatives", error);
          toast.error("An error occurred. Please try again.");
        }
      } catch (error) {
        console.error("Invalid token or unable to decode", error);
        navigate(route.login); // Redirect if token is invalid
      }
    };

    fetchData();
  }, [
    currentPage,
    itemsPerPage,
    // filterStatus,
    searchClicked,
    refresh,
  ]);

  const handlePageChange = (page: number) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    console.log("Current page:", currentPage);
  }, [currentPage]);

  interface ReasonPopoverProps {
    reason: string;
  }

  const renderReasonPopover = ({ reason }: ReasonPopoverProps): JSX.Element => (
    <Popover id="popover-reason">
      <Popover.Body>{reason}</Popover.Body>
    </Popover>
  );

  const handleCreateClean = () => {
    setRepresentativeName("");
    setContact("");
    setNic("");
    setDob("");
    setEmail("");
    setWhatsapp("");
    setSelectedRepresentativeId(null);
    setAddress("");
    setDescription("");
    setIsRepresentativeNameValid(false);
    setIsAddressValid(false);
    setIsNicValid(false);
    setIsDobInvalid(false);
    setIsWhatsappValid(false);
    setIsContactValid(false);
    setIsEmailValid(false);
  };

  const handleCreate = () => {
    let isvalid = true;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (representativeName === "") {
      isvalid = false;
      setIsRepresentativeNameValid(true);
    } else {
      setIsRepresentativeNameValid(false);
    }

    if (contact === "") {
      isvalid = false;
      setIsContactValid(true);
    } else {
      setIsContactValid(false);
    }

    if (whatsapp === "") {
      isvalid = false;
      setIsWhatsappValid(true);
    } else {
      setIsWhatsappValid(false);
    }

    if (!contact || contact.length !== 10) {
      isvalid = false;
      setIsContactValid(true);
    } else {
      setIsContactValid(false);
    }

    if (!whatsapp || whatsapp.length !== 10) {
      isvalid = false;
      setIsWhatsappValid(true);
    } else {
      setIsWhatsappValid(false);
    }

    if (!email || !emailRegex.test(email)) {
      isvalid = false;
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }

    if (Address === "") {
      isvalid = false;
      setIsAddressValid(true);
    } else {
      setIsAddressValid(false);
    }

    if (nic.length === 12) {
      setIsNicValid(false);
    } else if (nic.length === 10 && (nic.endsWith("v") || nic.endsWith("V"))) {
      setIsNicValid(false);
    } else {
      setIsNicValid(true);
    }

    if (dob === "") {
      isvalid = false;
      setIsDobInvalid(true);
    } else {
      setIsDobInvalid(false);
    }

    if (isvalid) {
      const payload = {
        name: representativeName,
        nic: nic,
        phone: contact,
        dateOfBirth: dob,
        whatsappNumber: whatsapp,
        email: email,
        address: Address,
        description: description,
      };

      Swal.fire({
        title: "Do You Want To Add The Representative?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes, Add This Representative",
        denyButtonText: `No, Cancel`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Adding Representative...");
              // Token is valid, proceed with the API call

              const response = await apiDefinitions.createRepresentative(
                token,
                employeeId,
                payload
              );

              if (response.data.code === 200) {
                toast.dismiss(toastId);
                console.log("Response", response.data.data);
                handleCreateClean();
                window.location.reload();
                toast.success("Representative Created Successfully", {
                  duration: 5000,
                });
              } else if (response.data.code === 409) {
                toast.dismiss(toastId);
                toast.error(response.data.message);
              } else {
                toast.dismiss(toastId);
                toast.error("Failed to Create Representative");
              }
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        } else {
          toast("Cancelled", {
            icon: "⚠️",
          });
        }
      });
    } else {
      console.error(
        "Form validation failed. Please check the form for errors."
      );
    }
  };

  const handleUpdate = () => {
    let isvalid = true;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (representativeName === "") {
      isvalid = false;
      setIsRepresentativeNameValid(true);
    } else {
      setIsRepresentativeNameValid(false);
    }

    if (contact === "") {
      isvalid = false;
      setIsContactValid(true);
    } else {
      setIsContactValid(false);
    }

    if (whatsapp === "") {
      isvalid = false;
      setIsWhatsappValid(true);
    } else {
      setIsWhatsappValid(false);
    }

    if (!contact || contact.length !== 10) {
      isvalid = false;
      setIsContactValid(true);
    } else {
      setIsContactValid(false);
    }

    if (!whatsapp || whatsapp.length !== 10) {
      isvalid = false;
      setIsWhatsappValid(true);
    } else {
      setIsWhatsappValid(false);
    }

    if (!email || !emailRegex.test(email)) {
      isvalid = false;
      setIsEmailValid(true);
    } else {
      setIsEmailValid(false);
    }

    if (Address === "") {
      isvalid = false;
      setIsAddressValid(true);
    } else {
      setIsAddressValid(false);
    }

    if (nic.length === 12) {
      setIsNicValid(false);
    } else if (nic.length === 10 && (nic.endsWith("v") || nic.endsWith("V"))) {
      setIsNicValid(false);
    } else {
      isvalid = false;
      setIsNicValid(true);
    }

    if (dob === "") {
      isvalid = false;
      setIsDobInvalid(true);
    } else {
      setIsDobInvalid(false);
    }

    if (isvalid) {
      const payload = {
        name: representativeName,
        nic: nic,
        phone: contact,
        dateOfBirth: dob,
        whatsappNumber: whatsapp,
        email: email,
        address: Address,
        description: description,
      };

      Swal.fire({
        title: "Do You Want To Update The Representative?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Yes, Update Representative",
        denyButtonText: `No, Cancel`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const token = sessionStorage.getItem("token");
          if (!token) {
            console.error("No token found. Please log in again.");
            return;
          }

          try {
            const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
            const currentTime = Math.floor(Date.now() / 1000);

            if (decodedToken.exp && decodedToken.exp > currentTime) {
              const toastId = toast.loading("Updating Representative...");
              // Token is valid, proceed with the API call

              const response = await apiDefinitions.updateRepresentative(
                token,
                selectedRepresentativeId,
                employeeId,
                payload
              );

              if (response.data.code === 200) {
                toast.dismiss(toastId);
                console.log("Response", response.data.data);
                handleCreateClean();
                window.location.reload();
                toast.success("Representative Updated Successfully", {
                  duration: 5000,
                });
              } else {
                toast.dismiss(toastId);
                toast.error("Failed to Update Representative");
              }
            } else {
              console.log("Session expired. Please log in again.");
              navigate(route.login);
            }
          } catch (error) {
            console.error("Invalid token or unable to decode", error);
          }
        } else {
          toast("Cancelled", {
            icon: "⚠️",
          });
        }
      });
    } else {
      console.error(
        "Form validation failed. Please check the form for errors."
      );
    }
  };

  interface Option {
    value: number;
    label: string;
  }

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      console.log("Decoded Token", decodedToken);

      setEmployeeId(decodedToken.serial_number);
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("token");

    if (!token) {
      console.error("No token found. Please log in again.");
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token) as DecodedToken;
      const currentTime = Math.floor(Date.now() / 1000);

      if (decodedToken.exp && decodedToken.exp > currentTime) {
        apiDefinitions.getMarketingEmployeeList().then((response: any) => {
          console.log("Course Categories: ", response.data.data);
          setEmployeeList(response.data.data);
        });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
    }
  }, []);

  const handleSearch = () => {
    setSearchClicked(!searchClicked);
  };

  const handleSearchClose = () => {
    setSearchClicked(!searchClicked);
    setSearchKey("");
    setFilterStatus("");
  };

  const handleActiveStatus = (id: number, activeInactiveStatus: boolean) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    const status = !activeInactiveStatus;

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const loadingToastId = toast.loading("Changing Status...");
        apiDefinitions
          .representativeStatus(token, id, status, employeeId)
          .then((response: any) => {
            if (response.data.code === 200) {
              toast.dismiss(loadingToastId);
              setRefresh(!refresh);
              toast.success("Status Changed Successfully");
            } else {
              toast.dismiss(loadingToastId);
              toast.error("Failed to Change Status");
            }
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  const handleGetRepresentative = (id: number) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No token found. Please log in again.");
      navigate(route.login);
      return;
    }

    try {
      const decodedToken: DecodedToken = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decodedToken.exp && decodedToken.exp > currentTime) {
        const loadingToastId = toast.loading("Fetching Details...");
        apiDefinitions
          .getRepresentativeById(token, id)
          .then((response: any) => {
            if (response.data.code === 200) {
              toast.dismiss(loadingToastId);
              toast.success("Details Loaded Successfully");
              setRepresentativeName(response.data.data.name);
              setContact(response.data.data.phone);
              setNic(response.data.data.nic);
              setDob(response.data.data.dateOfBirth);
              setEmail(response.data.data.email);
              setWhatsapp(response.data.data.whatsappNumber);
              setSelectedRepresentativeId(id);
              setAddress(response.data.data.address);
              setDescription(response.data.data.description);
            } else {
              toast.dismiss(loadingToastId);
              toast.error("Failed to Load Details");
            }
          });
      } else {
        console.log("Session expired. Please log in again.");
        navigate(route.login);
      }
    } catch (error) {
      console.error("Invalid token or unable to decode", error);
      navigate(route.login);
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">View Representatives</div>
                  <div className="row">
                    <div className="col-md-1 mb-3 mt-3">
                      <Form.Select
                        value={itemsPerPage}
                        onChange={(event) =>
                          setItemsPerPage(parseInt(event.target.value, 10))
                        }
                        aria-label="Select number of items per page"
                        className="w-auto"
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </Form.Select>
                    </div>

                    <div className="col-md-4 mt-3">
                      <input
                        type="text"
                        className="form-control"
                        id="validationCustom01"
                        placeholder="Search"
                        value={searchKey}
                        onChange={(e) => setSearchKey(e.target.value)}
                        required
                      />
                    </div>

                    <div className="col-md-3 mt-3">
                      <select
                        className={`form-select`}
                        id="validationCustomContactMethod"
                        value={filterStatus}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        required
                      >
                        <option value="" disabled>
                          Select a status
                        </option>
                        <option value="true">Active </option>
                        <option value="false">Inactive</option>
                      </select>
                    </div>

                    <div className="col-md-1 mt-3" style={{ textAlign: "end" }}>
                      <button
                        className="btn btn-primary"
                        onClick={
                          searchClicked ? handleSearchClose : handleSearch
                        }
                      >
                        <i
                          className={`fas ${
                            searchClicked ? "fa-times" : "fa-search"
                          }`}
                          style={{
                            marginRight: "5px",
                            padding: "4px",
                            fontSize: "15px",
                            marginLeft: "1px",
                          }}
                        ></i>
                      </button>
                    </div>

                    <div
                      className="col-md-12 mt-3"
                      style={{ textAlign: "start" }}
                    >
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light mt-1 me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#lead-export-modal"
                      >
                        <i
                          className="fas fa-plus"
                          style={{
                            marginRight: "5px",
                            padding: "4px",
                            fontSize: "15px",
                            marginLeft: "1px",
                          }}
                        ></i>{" "}
                        Add Representative
                      </button>
                    </div>
                  </div>
                </div>

                <div className="card-body">
                  <div className="table-responsive">
                    <table className="table text-nowrap table-striped">
                      <thead>
                        <tr>
                          <th scope="col">Representative's Name</th>
                          <th scope="col">Email</th>
                          <th scope="col">Contact Number</th>
                          <th scope="col">Status</th>
                          <th scope="col">Active/ Inactive Toggle</th>
                          <th scope="col">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leads.length > 0 ? (
                          leads.map((lead, index) => (
                            <tr key={index}>
                              <td>
                                {lead?.name?.length > 30 ? (
                                  <OverlayTrigger
                                    trigger={["hover", "focus"]}
                                    placement="top"
                                    overlay={renderReasonPopover({
                                      reason: lead.name,
                                    })}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                      }}
                                    >
                                      {lead.name.substring(0, 30)}...
                                    </span>
                                  </OverlayTrigger>
                                ) : (
                                  lead.name
                                )}
                              </td>
                              <td>{lead.email}</td>
                              <td>{lead.phone}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    lead.activeInactiveStatus === true
                                      ? "bg-soft-success"
                                      : "bg-soft-danger"
                                  }`}
                                >
                                  {lead.activeInactiveStatus === true
                                    ? "Active"
                                    : "Inactive"}
                                </span>
                              </td>
                              <td>
                                <div className="hstack gap-2 fs-15">
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      checked={lead.activeInactiveStatus}
                                      onChange={() => {
                                        handleActiveStatus(
                                          lead.id,
                                          lead.activeInactiveStatus
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="hstack gap-2 fs-15">
                                  <button
                                    type="button"
                                    className="btn btn-success waves-effect waves-light mt-1 me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#view-modal"
                                    onClick={() => {
                                      handleGetRepresentative(lead.id);
                                    }}
                                  >
                                    <i className="fas fa-eye"></i>{" "}
                                  </button>

                                  <button
                                    type="button"
                                    className="btn btn-info waves-effect waves-light mt-1 me-1"
                                    data-bs-toggle="modal"
                                    data-bs-target="#update-modal"
                                    onClick={() => {
                                      handleGetRepresentative(lead.id);
                                    }}
                                  >
                                    <i className="fas fa-edit"></i>{" "}
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={9} className="text-center">
                              No Data Available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <Pagination className="mt-3 justify-content-center">
                    <Pagination.Prev
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 1}
                    />
                    {Array.from({ length: totalPages }, (_, index) => (
                      <Pagination.Item
                        key={index + 1}
                        active={index + 1 === currentPage}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Pagination.Item>
                    ))}
                    <Pagination.Next
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="lead-export-modal"
        tabIndex={-1}
        aria-labelledby="lead-export-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lead-export-modal-label">
                Add Representative
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCreateClean}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Representative's Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isRepresentativeNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Representative Name"
                    value={representativeName}
                    onChange={(e) => setRepresentativeName(e.target.value)}
                    required
                  />
                  {isRepresentativeNameValid && (
                    <div className="invalid-feedback">Please enter a name.</div>
                  )}
                </div>

                <div className="col-md-3 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    NIC
                  </label>
                  <input
                    type="text"
                    className={`form-control ${isNicValid ? "is-invalid" : ""}`}
                    id="validationCustom01"
                    placeholder="NIC"
                    value={nic}
                    onChange={(e) => setNic(e.target.value)}
                    required
                  />
                  {isNicValid && (
                    <div className="invalid-feedback">
                      Please enter a valid NIC.
                    </div>
                  )}
                </div>

                <div className="col-md-3 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomFollowUpDate"
                  >
                    Date Of Birth
                  </label>
                  <input
                    type="date"
                    className={`form-control ${
                      isDobInvalid ? "is-invalid" : ""
                    }`}
                    id="validationCustomFollowUpDate"
                    value={dob}
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) => setDob(e.target.value)}
                    required
                  />
                  {isDobInvalid && (
                    <div className="invalid-feedback">
                      Please select a date of birth.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isContactValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {isContactValid && (
                    <div className="invalid-feedback">
                      Please enter a valid contact.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Whatsapp Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isWhatsappValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Whatsapp Number"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                    required
                  />
                  {isWhatsappValid && (
                    <div className="invalid-feedback">
                      Please enter a valid whatsapp number.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isEmailValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {isEmailValid && (
                    <div className="invalid-feedback">
                      Please enter a valid email.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Address
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isAddressValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Address"
                    value={Address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                  {isAddressValid && (
                    <div className="invalid-feedback">
                      Please enter an address.
                    </div>
                  )}
                </div>

                <div className="col-md-12 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Description
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleCreateClean}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                onClick={handleCreate}
              >
                Add Representative
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="update-modal"
        tabIndex={-1}
        aria-labelledby="lead-export-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lead-export-modal-label">
                Update Representatives
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCreateClean}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Representative's Name
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isRepresentativeNameValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Representative Name"
                    value={representativeName}
                    onChange={(e) => setRepresentativeName(e.target.value)}
                    required
                  />
                  {isRepresentativeNameValid && (
                    <div className="invalid-feedback">Please enter a name.</div>
                  )}
                </div>

                <div className="col-md-3 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    NIC
                  </label>
                  <input
                    type="text"
                    className={`form-control ${isNicValid ? "is-invalid" : ""}`}
                    id="validationCustom01"
                    placeholder="NIC"
                    value={nic}
                    onChange={(e) => setNic(e.target.value)}
                    required
                  />
                  {isNicValid && (
                    <div className="invalid-feedback">
                      Please enter a valid NIC.
                    </div>
                  )}
                </div>

                <div className="col-md-3 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomFollowUpDate"
                  >
                    Date Of Birth
                  </label>
                  <input
                    type="date"
                    className={`form-control ${
                      isDobInvalid ? "is-invalid" : ""
                    }`}
                    id="validationCustomFollowUpDate"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    required
                  />
                  {isDobInvalid && (
                    <div className="invalid-feedback">
                      Please select a date of birth.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isContactValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {isContactValid && (
                    <div className="invalid-feedback">
                      Please enter a valid contact.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Whatsapp Number
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isWhatsappValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Whatsapp Number"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                    required
                  />
                  {isWhatsappValid && (
                    <div className="invalid-feedback">
                      Please enter a valid whatsapp number.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isEmailValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {isEmailValid && (
                    <div className="invalid-feedback">
                      Please enter a valid email.
                    </div>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Address
                  </label>
                  <input
                    type="text"
                    className={`form-control ${
                      isAddressValid ? "is-invalid" : ""
                    }`}
                    id="validationCustom01"
                    placeholder="Address"
                    value={Address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                  />
                  {isAddressValid && (
                    <div className="invalid-feedback">
                      Please enter an address.
                    </div>
                  )}
                </div>

                <div className="col-md-12 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Description
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleCreateClean}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary waves-effect waves-light"
                onClick={handleUpdate}
              >
                Update
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="view-modal"
        tabIndex={-1}
        aria-labelledby="lead-export-modal-label"
        aria-hidden="true"
      >
        <div className="modal-dialog" style={{ maxWidth: "900px" }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="lead-export-modal-label">
                View Representative Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={handleCreateClean}
              ></button>
            </div>

            <div className="modal-body p-4">
              <div className="row">
                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Representative's Name
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="Representative Name"
                    value={representativeName}
                    onChange={(e) => setRepresentativeName(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    NIC
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="NIC"
                    value={nic}
                    onChange={(e) => setNic(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomFollowUpDate"
                  >
                    Date Of Birth
                  </label>
                  <input
                    type="date"
                    className={`form-control `}
                    id="validationCustomFollowUpDate"
                    value={dob}
                    onChange={(e) => setDob(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Contact Number
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={contact}
                    onChange={(e) => setContact(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Whatsapp Number
                  </label>
                  <input
                    type="text"
                    className={`form-control `}
                    id="validationCustom01"
                    placeholder="Whatsapp Number"
                    value={whatsapp}
                    onChange={(e) => setWhatsapp(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Email
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="Contact Number"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-6 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Address
                  </label>
                  <input
                    type="text"
                    className={`form-control `}
                    id="validationCustom01"
                    placeholder="Address"
                    value={Address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                    disabled
                  />
                </div>

                <div className="col-md-12 mt-3">
                  <label
                    className="form-label"
                    htmlFor="validationCustomContactMethod"
                  >
                    Description
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    id="validationCustom01"
                    placeholder="Description"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-cancel waves-effect"
                data-bs-dismiss="modal"
                onClick={handleCreateClean}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAllRepresentatives;
